import { render, staticRenderFns } from "./ditch_pz_edit.vue?vue&type=template&id=35686f86&scoped=true&"
import script from "./ditch_pz_edit.vue?vue&type=script&lang=js&"
export * from "./ditch_pz_edit.vue?vue&type=script&lang=js&"
import style0 from "./ditch_pz_edit.vue?vue&type=style&index=0&id=35686f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35686f86",
  null
  
)

export default component.exports